import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { GridFiltersView } from './GridFiltersView';

export const templateGridFilters = document.createElement('template');

templateGridFilters.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styleHelpers}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <div class="filters-container">
        <span id="filters-separator"></span>
        <gz-enum-filter
            class="filter"
            id=${GridFiltersView.MORE_FILTERS_ID}
            keepConfirmButtonEnabled
            autoAdjustMenuPosition
            ></gz-enum-filter>
            <span class="reset-filters-wrapper" id="clearFiltersWrapper">
            <gz-button
            type="quiet"
            color="primary"
            buttonHeight="small"
            buttonFontSize="small"
            lowercase
            id="clearFilters"
          >
          </gz-button>
</span>
    </div>
  </div>
`;
